var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',_vm._g(_vm._b({},'el-image',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"cmm-image-error",attrs:{"slot":"error"},slot:"error"},[_c('img',{attrs:{"src":require("@cdn?cc20d952f52a")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }